import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Search",
  "use": "Search-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Search\"><path fill-rule=\"evenodd\" d=\"M26.208 43.244c-9.08 0-16.442-7.361-16.442-16.442S17.127 10.36 26.208 10.36 42.65 17.72 42.65 26.802c0 9.08-7.36 16.442-16.442 16.442zm35.988 11.559L47.41 40.233a24.677 24.677 0 0 0 3.957-13.431C51.366 13.104 40.262 2 26.566 2 12.866 2 1.762 13.104 1.762 26.802s11.104 24.802 24.802 24.802c4.761 0 9.208-1.345 12.985-3.671l14.925 14.705 7.721-7.835z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol